// extracted by mini-css-extract-plugin
module.exports = {"inputTime":"input-time_inputTime__2fhiw","separator":"input-time_separator__1Eymh","clear":"input-time_clear__3aPZ7"};